export default [
    {
        path: "/sheet-roll/:id",
        component: () => import("@/App/User/SheetRoll/Components/SheetRoll.vue"),
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: "basic",
                component: () => import("@/App/User/SheetRoll/Components/Basic.vue"),
                name: "sheet-roll-basic",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "address",
                component: () => import("@/App/User/SheetRoll/Components/Address.vue"),
                name: "sheet-roll-address",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "details",
                component: () => import("@/App/User/SheetRoll/Components/Details.vue"),
                name: "sheet-roll-details",
                meta: {
                    requiresAuth: true,
                },
            },

            {
                path: "education",
                component: () => import("@/App/User/SheetRoll/Components/Education.vue"),
                name: "sheet-roll-education",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "admission-training-information",
                component: () => import("@/App/User/SheetRoll/Components/Training.vue"),
                name: "sheet-roll-admission-training-information",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "appointments",
                component: () => import("@/App/User/SheetRoll/Components/Recruitments.vue"),
                name: "sheet-roll-appointments",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "special-qualifications",
                component: () => import("@/App/User/SheetRoll/Components/SpecialQualification.vue"),
                name: "sheet-roll-special-qualifications",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "annual-confidential-report",
                component: () => import("@/App/User/SheetRoll/Components/ConfidentialReport.vue"),
                name: "sheet-roll-annual-confidential-report",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "general-casual-event-transfers",
                component: () => import("@/App/User/SheetRoll/Components/GeneralCasualEventTransfers.vue"),
                name: "sheet-roll-general-casual-event-transfers",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "general-promotion-demotion-stabilization",
                component: () => import("@/App/User/SheetRoll/Components/GeneralCasualEventsPromotions.vue"),
                name: "sheet-roll-general-promotion-demotion-stabilization",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "general-medical-matter",
                component: () => import("@/App/User/SheetRoll/Components/GeneralMedicalMatter.vue"),
                name: "sheet-roll-general-medical-matter",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "general-event-other",
                component: () => import("@/App/User/SheetRoll/Components/GeneralEventOther.vue"),
                name: "sheet-roll-general-event-other",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "behavior-description",
                component: () => import("@/App/User/SheetRoll/Components/BehaviorDescription.vue"),
                name: "sheet-roll-behavior-description",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "behavior-description-warning",
                component: () => import("@/App/User/SheetRoll/Components/BehaviorDescriptionWarning.vue"),
                name: "sheet-roll-behavior-description-warning",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "files",
                component: () => import("@/App/User/SheetRoll/Components/Files.vue"),
                name: "sheet-roll-files",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "training-sheet",
                component: () => import("@/App/User/SheetRoll/Components/TrainingSheet.vue"),
                name: "training-sheet",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "print-sheet-roll",
                component: () => import("@/App/User/SheetRoll/Components/PrintSheetRoll.vue"),
                name: "print-sheet-roll",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "overseas-jobs-honors",
                component: () => import("@/App/User/SheetRoll/Components/OverseasJobsHonors.vue"),
                name: "sheet-roll-overseas-jobs-honors",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "annual-leave",
                component: () => import("@/App/User/SheetRoll/Components/AnnualLeave.vue"),
                name: "sheet-roll-annual-leave",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "recreation-leave",
                component: () => import("@/App/User/SheetRoll/Components/RecreationLeave.vue"),
                name: "sheet-roll-recreation-leave",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "salary-increase",
                component: () => import("@/App/User/SheetRoll/Components/SalaryIncrease.vue"),
                name: "sheet-roll-salary-increase",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "allowances",
                component: () => import("@/App/User/SheetRoll/Components/Allowances.vue"),
                name: "sheet-roll-allowances",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "other-allowances",
                component: () => import("@/App/User/SheetRoll/Components/OtherAllowances.vue"),
                name: "sheet-roll-other-allowances",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "loans-deductions",
                component: () => import("@/App/User/SheetRoll/Components/LoansDeductions.vue"),
                name: "sheet-roll-loans-deductions",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "army-family-security",
                component: () => import("@/App/User/SheetRoll/Components/ArmyFamilySecurity.vue"),
                name: "sheet-roll-army-family-security",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "nominated-names",
                component: () => import("@/App/User/SheetRoll/Components/NominatedNames.vue"),
                name: "sheet-roll-nominated-names",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "army-health-insurance",
                component: () => import("@/App/User/SheetRoll/Components/ArmyHealthInsurance.vue"),
                name: "sheet-roll-army-health-insurance",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "inactive-statement-account",
                component: () => import("@/App/User/SheetRoll/Components/InactiveStatementAccount.vue"),
                name: "sheet-roll-inactive-statement-account",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "reserved-soldiers",
                component: () => import("@/App/User/SheetRoll/Components/ReservedSoldiers.vue"),
                name: "sheet-roll-reserved-soldiers",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "nearest-relatives",
                component: () => import("@/App/User/SheetRoll/Components/NearestRelatives.vue"),
                name: "sheet-roll-nearest-relatives",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "death-account",
                component: () => import("@/App/User/SheetRoll/Components/DeathAccount.vue"),
                name: "sheet-roll-death-account",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "department-defense-finance",
                component: () => import("@/App/User/SheetRoll/Components/DepartmentDefenseFinance.vue"),
                name: "sheet-roll-department-defense-finance",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "personal-information",
                component: () => import("@/App/User/SheetRoll/Components/PersonalInformation.vue"),
                name: "sheet-roll-personal-information",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "characteristic",
                component: () => import("@/App/User/SheetRoll/Components/Characteristic.vue"),
                name: "sheet-roll-characteristic",
                meta: {
                    requiresAuth: true,
                },
            },
        ],
    },
];
